module.exports = __webpack_public_path__ + "static/media/product-placeholder.e8344104.svg";